import React from 'react'

const IconStart = props => (
  <svg viewBox="0 0 20 20" {...props}>
    <g fill="#28D88C">
      <path d="M15.601 8.8c-1.8.2-3.5-1.8-3.5-1.8s1.3-2.3 3.1-2.5c1.2 0 2.3.5 3.1 1.4.2.2.3.6.1.9-.6 1-1.6 1.7-2.8 2z" />
      <path d="M10.001 4.4c.1 1.6 2.1 2.6 2.1 2.6s1.7-1.4 1.5-3c-.2-1-.8-1.8-1.6-2.3-.3-.2-.7-.1-.9.1-.7.7-1.1 1.6-1.1 2.6z" />
    </g>
    <path
      fill="#28D88C"
      d="M8.972 5.006l-6 4.7v7.1c0 .9.7 1.6 1.6 1.6h8.9c.9 0 1.6-.7 1.6-1.6v-7.1l-6.1-4.7z"
    />
    <path
      fill="#09C5B8"
      d="M15.2 10.773L9 5.973l-6.3 4.8c-.4.2-.8.1-1.1-.2-.2-.3-.2-.8.2-1.1l6.7-5.1c.3-.2.7-.2 1 0l6.7 5.1c.3.2.4.7.2 1-.3.4-.8.5-1.2.3zM8.072 13.306h1.7c.8 0 1.4.6 1.4 1.4v3.6h-4.5v-3.6c0-.7.6-1.4 1.4-1.4z"
    />
  </svg>
);

export default IconStart



// WEBPACK FOOTER //
// ./src/components/SVG/Navbar/IconStart.js